import React from 'react';

import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { useHistory } from 'react-router-dom';

import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE } from '../config/auht0-config';
import { logGAEvent } from '../util/log-ga';

type Auth0ProviderProps = {
  children: React.ReactNode;
};

/**
 * This component sets up the Auth0Provider, and allows for the `useAuth0` hook to be
 * used in children. Note that this doesn't force authentication, but rather just sets
 * up a context to store credentials in.
 */
export const AuthenticationProvider = ({ children }: Auth0ProviderProps) => {
  const history = useHistory();
  const domain = AUTH0_DOMAIN;
  const clientId = AUTH0_CLIENT_ID;
  const audience = AUTH0_AUDIENCE;

  // Called when we get back the App
  const onRedirectCallback = (appState: AppState) => {
    logGAEvent('Employer', 'Logged In');
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      audience={audience}
      useRefreshTokens
    >
      {children}
    </Auth0Provider>
  );
};
